// Auto-detect environment for seamless local and production deployment
const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
const protocol = typeof window !== 'undefined' ? window.location.protocol : 'http:';

// Use /api for production to go through Nginx proxy, direct port for local development
export const BASE_URL = isLocal 
  ? "http://localhost:8081"
  : `${protocol}//${hostname}/api`;

// Image URL configuration
// Local: Points to locally served ecomuploads folder (http://localhost:8081/ecomuploads)
// Production: Points to server's ecomuploads folder via Nginx
export const IMG_URL = isLocal
  ? `${BASE_URL}/ecomuploads`
  : `${protocol}//${hostname}/ecomuploads`;

export const DEF_IMG_BRA = "https://cdn.magicdecor.in/com/2024/10/11185630/Pleasant-Modern-Landscape-Wallpaper-M.jpg"
